module.exports = __webpack_public_path__ + "static/img_4795-9575fc7afa74b91c78dc2ed1fde41b9f.webp";